import { useState } from "react";
import { AiFillTwitterCircle, AiFillInstagram } from "react-icons/ai";
import { FaDiscord } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
export default function Footer() {
  const [date, setDate] = useState(new Date());
  return (
    <>
      <footer>
        <div className="footer-section-1">
          <div className="footer-nav">
            <span className="footer-item">
              <h3>Soporte</h3>
              <a className="footer-link" href="https://mmods.es/contacto">
                <p>Contacto</p>
              </a>
              <a
                className="footer-link"
                href="https://mmods.es/politica-de-privacidad/"
              >
                <p>Política de privacidad</p>
              </a>
            </span>
            <span className="footer-item">
              <h3>Mods</h3>
              <a className="footer-link" href="https://mmods.es/mods/lista">
                <p>Mods gratuitos</p>
              </a>
              <a className="footer-link" href="https://mmods.es/mods/catalogo">
                <p>Catálogo de mods</p>
              </a>
            </span>
            <span className="footer-item">
              <h3>Sobre mmodsgtav</h3>
              <a className="footer-link" href="https://mmods.es/">
                <p>Web principal</p>
              </a>
              <a className="footer-link" href="https://mmods.es/blog">
                <p>Blog</p>
              </a>
              <a
                className="footer-link"
                href="https://mmods.es/blog/tutoriales"
              >
                <p>Tutoriales</p>
              </a>
              <a className="footer-link" href="https://mmods.es/portfolio/">
                <p>Portfolio</p>
              </a>
              <a
                className="footer-link"
                href="https://mmods.es/proyectos-en-curso/"
              >
                <p>Proyectos</p>
              </a>
            </span>
          </div>
          <Social />
          <p className="about-text color-white">
            © {date.getFullYear()} MmodsGTAV
          </p>
        </div>
      </footer>
    </>
  );
}

export function Social() {
  return (
    <div className="rrss-holder">
      <a
        className="footer-link rr-ss-link"
        rel="noreferrer"
        href="https://mmodsgtav.com/ig"
        target="_blank"
      >
        {<AiFillTwitterCircle />}
      </a>
      <a
        className="footer-link rr-ss-link"
        rel="noreferrer"
        href="https://mmodsgtav.com/tw"
        target="_blank"
      >
        {<AiFillInstagram />}
      </a>
      <a
        className="footer-link rr-ss-link"
        rel="noreferrer"
        href="https://mmodsgtav.com/dc"
        target="_blank"
      >
        {<FaDiscord />}
      </a>
      <a
        className="footer-link rr-ss-link"
        rel="noreferrer"
        href="mailto:contacto@mmods.es"
        target="_blank"
      >
        {<HiOutlineMail />}
      </a>
    </div>
  );
}
